module.exports = __webpack_public_path__ + "static/foto_minigaleria2-353cdf683eba24a44154ca0b1f13ceae.jpg";